var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowerTubUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shower-tub-update",
    viewBox: "-2.5 -2.5 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.871 16.467h25.258m-25.258 0v1.6666c0 3.3137 2.6863 6 6 6h13.258c3.3137 0 6-2.6863 6-6v-1.6666m-25.258 0h-1.871m27.129 0v-9.6667c0-3.2032-2.3396-5.8-5.2258-5.8-2.8861 0-5.2258 2.5968-5.2258 5.8v1.45m10.452 8.2167h1.871m-21.857 7.6666-0.9168 2.8667m16.503-2.8667 0.9168 2.8667m-6.9678-18.75h-2.6129m2.6129 0h2.6129m-17.29-3.25 4-4 4 4m-4-4v12",
    fill: "none",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerTubUpdate);
export default __webpack_public_path__ + "static/media/shower-tub-update.bb1122002f65786596e1334144135c52.svg";
export { ForwardRef as ReactComponent };